import { render, staticRenderFns } from "./LazyDropdown.vue?vue&type=template&id=1507f608&scoped=true&"
import script from "./LazyDropdown.vue?vue&type=script&lang=js&"
export * from "./LazyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LazyDropdown.vue?vue&type=style&index=0&id=1507f608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507f608",
  null
  
)

export default component.exports